import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGenehmigungDefinitionHistoryListStatus: 'idle',
    loadGenehmigungDefinitionHistoryListError: undefined as any,
    loadGenehmigungDefinitionHistoryListLastParams: undefined as string | undefined,
    createGenehmigungDefinitionHistoryStatus: 'idle',
    createGenehmigungDefinitionHistoryError: undefined as any,
    updateGenehmigungDefinitionHistoryStatus: 'idle',
    updateGenehmigungDefinitionHistoryError: undefined as any,
    deleteGenehmigungDefinitionHistoryStatus: 'idle',
    deleteGenehmigungDefinitionHistoryError: undefined as any,

    genehmigungDefinitionHistoryList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadGenehmigungDefinitionHistoryList = createAsyncThunk('genehmigungDefinitionHistorySlice/loadGenehmigungDefinitionHistoryList', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadGenehmigungDefinitionHistoryListLastParams } = getState().genehmigungDefinitionHistorySlice
    const url = `/api/ixweb/nurisgenehmdefhist/`

    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadGenehmigungDefinitionHistoryListLastParams && !forceReload) {
        return
    }

    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
},
{
    condition: (_, { getState }) => {
        const state = getState() as any
        const reducerStatus = state.genehmigungDefinitionHistorySlice.loadGenehmigungDefinitionHistoryListStatus
        return reducerStatus !== 'preloaded'
    }
})
export const createGenehmigungDefinitionHistory = createAsyncThunk('genehmigungDefinitionHistorySlice/createGenehmigungDefinitionHistory', async (genehmigungDefinitionHistory: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmdefhist/`


    const reducerStatus = (getState() as any).genehmigungDefinitionHistorySlice.loadGenehmigungDefinitionHistoryListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = genehmigungDefinitionHistory
    } else {
        res = await client.post(url, prepareData(genehmigungDefinitionHistory))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...genehmigungDefinitionHistory, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateGenehmigungDefinitionHistory = createAsyncThunk('genehmigungDefinitionHistorySlice/updateGenehmigungDefinitionHistory', async (genehmigungDefinitionHistory: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmdefhist/${genehmigungDefinitionHistory.HDR_ID}/`


    const reducerStatus = (getState() as any).genehmigungDefinitionHistorySlice.loadGenehmigungDefinitionHistoryListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = genehmigungDefinitionHistory
    } else {
        res = await client.put(url, prepareData(genehmigungDefinitionHistory))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return genehmigungDefinitionHistory
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteGenehmigungDefinitionHistory = createAsyncThunk('genehmigungDefinitionHistorySlice/deleteGenehmigungDefinitionHistory', async (id: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmdefhist/${id}/`


    const reducerStatus = (getState() as any).genehmigungDefinitionHistorySlice.loadGenehmigungDefinitionHistoryListStatus
    let res: any = {}
    if (reducerStatus !== 'preloaded') {
        res = await client.delete(
            url,
            {
            }
        )
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const GenehmigungDefinitionHistorySlice = createSlice({
    name: 'genehmigungDefinitionHistorySlice',
    initialState,
    reducers: {
        resetloadGenehmigungDefinitionHistoryListError: (state) => {
            state.loadGenehmigungDefinitionHistoryListError = undefined
        },
        resetcreateGenehmigungDefinitionHistoryError: (state) => {
            state.createGenehmigungDefinitionHistoryError = undefined
        },
        resetupdateGenehmigungDefinitionHistoryError: (state) => {
            state.updateGenehmigungDefinitionHistoryError = undefined
        },
        resetdeleteGenehmigungDefinitionHistoryError: (state) => {
            state.deleteGenehmigungDefinitionHistoryError = undefined
        },
        removeFromGenehmigungDefinitionHistoryListById: (state, action) => {
            state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.genehmigungDefinitionHistoryList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGenehmigungDefinitionHistoryListStatus = 'preloaded'
            state.loadGenehmigungDefinitionHistoryListLastParams = ''
        },
        clearPreloadedData: (state) => {
            state.genehmigungDefinitionHistoryList = []
            state.loadGenehmigungDefinitionHistoryListStatus = 'idle'
            state.loadGenehmigungDefinitionHistoryListLastParams = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGenehmigungDefinitionHistoryList.pending, (state) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'pending'
            state.loadGenehmigungDefinitionHistoryListError = undefined
        })
        builder.addCase(loadGenehmigungDefinitionHistoryList.fulfilled, (state, action) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGenehmigungDefinitionHistoryListLastParams = action.payload.params

            state.genehmigungDefinitionHistoryList = action.payload.data
        })
        builder.addCase(loadGenehmigungDefinitionHistoryList.rejected, (state, action) => {
            state.loadGenehmigungDefinitionHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungDefinitionHistoryListError = action.error.message
            } else {
                state.loadGenehmigungDefinitionHistoryListError = action.payload
            }
        })

        builder.addCase(createGenehmigungDefinitionHistory.pending, (state) => {
            state.createGenehmigungDefinitionHistoryStatus = 'pending'
            state.createGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(createGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.createGenehmigungDefinitionHistoryStatus = 'idle'


            state.genehmigungDefinitionHistoryList = [...state.genehmigungDefinitionHistoryList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
        })
        builder.addCase(createGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.createGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.createGenehmigungDefinitionHistoryError = action.payload
            }
        })

        builder.addCase(updateGenehmigungDefinitionHistory.pending, (state) => {
            state.updateGenehmigungDefinitionHistoryStatus = 'pending'
            state.updateGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(updateGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.updateGenehmigungDefinitionHistoryStatus = 'idle'


            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.genehmigungDefinitionHistoryList.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.genehmigungDefinitionHistoryList.push(updatedItem) }
                else { state.genehmigungDefinitionHistoryList[i] = { ...state.genehmigungDefinitionHistoryList[i], ...updatedItem } }
            }
        })
        builder.addCase(updateGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.updateGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.updateGenehmigungDefinitionHistoryError = action.payload
            }
        })

        builder.addCase(deleteGenehmigungDefinitionHistory.pending, (state) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'pending'
            state.deleteGenehmigungDefinitionHistoryError = undefined
        })
        builder.addCase(deleteGenehmigungDefinitionHistory.fulfilled, (state, action) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'idle'


            if (Array.isArray(action.payload)) {
                state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => !action.payload.includes(x.HDR_ID))
            } else {
                state.genehmigungDefinitionHistoryList = state.genehmigungDefinitionHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
            }
        })
        builder.addCase(deleteGenehmigungDefinitionHistory.rejected, (state, action) => {
            state.deleteGenehmigungDefinitionHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGenehmigungDefinitionHistoryError = action.error.message
            } else {
                state.deleteGenehmigungDefinitionHistoryError = action.payload
            }
        })

    }
})

export const {
    resetloadGenehmigungDefinitionHistoryListError,
    resetcreateGenehmigungDefinitionHistoryError,
    resetupdateGenehmigungDefinitionHistoryError,
    resetdeleteGenehmigungDefinitionHistoryError,
    removeFromGenehmigungDefinitionHistoryListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = GenehmigungDefinitionHistorySlice.actions
export default GenehmigungDefinitionHistorySlice.reducer
